import { 
    ACT_STATE_GET_REQUEST, ACT_STATE_GET_SUCCESS, ACT_STATE_GET_ERROR, 
    ACT_STATE_GET_BY_KEY_REQUEST, ACT_STATE_GET_BY_KEY_SUCCESS, ACT_STATE_GET_BY_KEY_ERROR, 
    ACT_STATE_ADD_REQUEST, ACT_STATE_ADD_SUCCESS, ACT_STATE_ADD_ERROR, 
    ACT_STATE_EDIT_REQUEST, ACT_STATE_EDIT_SUCCESS, ACT_STATE_EDIT_ERROR, 
    ACT_STATE_DELETE_REQUEST, ACT_STATE_DELETE_SUCCESS, ACT_STATE_DELETE_ERROR
} from "../constants/actStateConstants";

const initialState = {
    actStates: [],
    actState: {},
    loading: false,
    success: null,
    error: null,
    actStateRequestedCount: 0,
};

export const actStateReducer = (state = initialState, action) => {
    switch (action.type)     {
        case ACT_STATE_GET_REQUEST:
            return {
                ...state,
                actStateRequestedCount: ++state.actStateRequestedCount,
                loading: true,
            };
        case ACT_STATE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                actStates: action.payload,
                success: true,
            };
        case ACT_STATE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case ACT_STATE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ACT_STATE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                actState: action.payload,
                success: true,
            };
        case ACT_STATE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case ACT_STATE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ACT_STATE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case ACT_STATE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case ACT_STATE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ACT_STATE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case ACT_STATE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case ACT_STATE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case ACT_STATE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case ACT_STATE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
